import en from './en';
import mm from './mm';
import zh from './zh';

export default {
  en,
  mm,
  zh
};